export const GET_SALARY_LIST = "get_salary_list";
export const UPDATE_SALARY_LIST = "update_salary_list";
export const TARIFF_CREATED = "tariff_created";
export const TARIFF_UPDATED = "tariff_updated";
export const TARIFF_DELETED = "tariff_deleted";
export const OPEN_TARIFF_MODAL = "open_tariff_modal";
export const CLOSE_TARIFF_MODAL = "close_tariff_modal";
export const GET_TARIFF_LIST = "get_tariff_list";
export const GET_NOT_PAYED_SALARY = "get_not_payed_salary";
export const PAY_SALARY = "pay_salary";
export const SHOW_PAYMENT_MODAL = "show_payment_modal";
export const HIDE_PAYMENT_MODAL = "hide_payment_modal";
